@if (!!group.inputs.length) {
  @if (group.config.removable) {
    <div class="remove-button-wrapper">
      <rt-icon-button
        (click)="clickRemove()"
        variant="plain"
        iconName="clear"
        class="remove-button danger-on-hover"
        shape="square"
      />
    </div>
  }

  @if (group.config.label) {
    <rt-heading variant="heading large" margin-bottom-small>
      {{ buildText(group.config.label) }}

      @if (group.config.helpTooltip) {
        <rt-icon-help
          [rtTooltip]="helpers.buildText(group.config.helpTooltip)"
          margin-left-small-x
        />
      }
    </rt-heading>
  }

  @for (input of group.inputs; track trackInput($index, input)) {
    @switch (input.kind) {
      @case ('DynamicFormInput') {
        <rti-dynamic-form-input [input]="$any(input)" />
      }

      @case ('DynamicFormGroup') {
        <rti-dynamic-form-group [group]="$any(input)" />
      }

      @case ('DynamicMessage') {
        @if (
          !isHidden(input) &&
          $any(input.config).text &&
          ($any(input.config).text.text || $any(input.config).text.key)
        ) {
          <rt-message
            [innerHTML]="buildText($any(input.config).text)"
            variant="context-information small"
            margin-bottom
          />
        }
      }

      @case ('DynamicListInfo') {
        <rti-dynamic-list-info [input]="$any(input)" />
      }

      @case ('DynamicInfo') {
        @if (!isHidden(input)) {
          <div layout-horizontal layout-align-items-center margin-bottom>
            <rt-icon
              name="info-outline"
              size="small"
              colorToken="colorIconLowDefault"
              margin-right-small-x
            />
            <span text-darkest>{{ buildText($any(input.config).text) }}</span>
          </div>
        }
      }

      @case ('DynamicLabel') {
        @if (
          !isHidden(input) &&
          $any(input.config).text &&
          ($any(input.config).text.text || $any(input.config).text.key)
        ) {
          <rt-heading
            [innerHTML]="buildText($any(input.config).text)"
            variant="heading large"
            margin-bottom
          />
        }
      }

      @case ('DynamicDivider') {
        @if (!isHidden(input)) {
          <rt-divider margin-bottom />
        }
      }
    }
  }
}
